import React from 'react';
import { Popup } from 'tdesign-react';
import {
  ExtensionIcon, FileMinusIcon, DownloadIcon,
  BookOpenIcon,
} from 'tdesign-icons-react';
import QrCode from '@/asserts/images/qr-code.png';
import s from './index.module.less';

const userGroup = (
  <div className={s.userGroup}>
    立即扫码加入用户交流群
    <div className={s.code}>
      <img src={QrCode} alt="" />
    </div>
  </div>
);

const helps = [{
  title: '帮助与支持',
  hoverContent: (
    <div className={s.tooltip}>
      <div className={s.title}>进入 ifBook 用户群获取更多帮助及支持！</div>
      <p className={s.desc}>第一时间获取 ifBook 更新公告推送、优秀实践分享、平台功能升级，高效解决使用问题！</p>
      <div className={s.boxes}>
        {userGroup}
        <div className={s.menus}>
          <a
            className={s.menusItem}
            href="https://ifbook.pages.woa.com/#/"
            target="_blank"
            rel="noreferrer"
          >
            ifBook 帮助文档
            <div className={s.icon}>
              <FileMinusIcon />
            </div>
          </a>
          <a
            className={s.menusItem}
            href="https://ifbook.pages.woa.com/#/apps/woa/ifbook-ext-zhiyan/docs/best-practice/index"
            target="_blank"
            rel="noreferrer"
          >
            ifBook 最佳实践
            <div className={s.icon}>
              <BookOpenIcon />
            </div>
          </a>
        </div>
      </div>
    </div>
  ),
}, {
  title: 'ifBook IDE 插件',
  hoverContent: (
    <div className={s.tooltip}>
      <div className={s.title}>ifBook VSCode IDE 插件抢先体验</div>
      <p className={s.desc}>ifBook 推出 VSCode IDE 插件，帮助研发侧本地进行接口及协议管理，专注本地研发环境减少焦点切换开销，极致提升 API 管理、开发、自测效率。</p>
      <div className={s.boxes}>
        {userGroup}
        <div className={s.menus}>
          <a
            className={s.menusItem}
            href="https://mirrors.tencent.com/repository/generic/ifBook-IDEHelper/VSCode/latest/ifbook.vsix"
          >
            下载安装
            <div className={s.icon}>
              <DownloadIcon />
            </div>
          </a>
          <a
            className={s.menusItem}
            href="https://ifbook.pages.woa.com/#/apps/woa/ifbook-ext-zhiyan/docs/ide_helper/index"
            target="_blank"
            rel="noreferrer"
          >
            插件使用说明
            <div className={s.icon}>
              <ExtensionIcon />
            </div>
          </a>
        </div>
      </div>
    </div>
  ),
}];

const NavHelps = () => (
  <div className={s.helps}>
    {
      helps.map((item, index) => (
        <Popup
          key={String(index + 1)}
          content={item?.hoverContent}
          placement="bottom-left"
          overlayClassName={s.popup}
          showArrow
        >
          <div className={s.helpItem} key={String(index + 1)}>
            {item.title}
          </div>
        </Popup>
      ))
    }
  </div>
);

export default NavHelps;
